import ReactGA from 'react-ga'

import { isProd } from '~/helpers/env'

ReactGA.initialize('UA-56464100-5', {
  debug: !isProd,
  testMode: !isProd,
});
ReactGA.pageview(window.location.pathname + window.location.search)
